var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cube-scroll-nav-panel"},[_c('cube-sticky-ele',{attrs:{"ele-key":_vm.label}},[_c('h2',{staticClass:"cube-scroll-nav-panel-title",domProps:{"innerHTML":_vm._s(_vm.title)}})]),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }